"use strict";

exports.__esModule = true;
exports.formatDate = void 0;
var LANGUAGE_MAP = {
  en: 'en-US',
  fr: 'fr-FR'
};
var formatDate = exports.formatDate = function formatDate(dateString, language) {
  var _dateString$split = dateString.split('/'),
    month = _dateString$split[0],
    day = _dateString$split[1],
    year = _dateString$split[2];
  var date = new Date(year, month - 1, day);
  var languageMap = LANGUAGE_MAP[language];

  // Helper function to capitalize only the first letter
  var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  // Get month name in the correct language
  var monthName = date.toLocaleString(languageMap, {
    month: 'short'
  });
  var formattedDay = String(date.getDate()).padStart(2, '0');
  var formattedYear = date.getFullYear();

  // Custom formatting for French: Month Day, Year
  if (languageMap === 'fr-FR') {
    var monthCapitalized = capitalizeFirstLetter(monthName);
    return monthCapitalized + " " + formattedDay + ", " + formattedYear;
  }

  // Default formatting for other languages
  return capitalizeFirstLetter(monthName) + " " + formattedDay + ", " + formattedYear;
};